import { useSelector } from 'react-redux';

import { priceTitleSelector } from 'reducers/filters';
import { SearchType } from 'search/SearchContext';
import { useSearchType } from './useSearchType';

export const useSelectPriceTitle = () => {
    const searchType = useSearchType();
    const { forSale, toRent } = useSelector(priceTitleSelector);

    return searchType === SearchType.ForSale ? forSale : toRent;
};
